import { Paper, ListItem } from '@material-ui/core'
import {
  SwxTheme,
  setToStyledComponent as styled
} from 'swx-atomic-component-lib'

/**
 * We had to define some styles as styled component for the following reasons
 * - We need to use the SwxTheme variables which cannot be used in SCSS
 * - We need to define pseudo-classes (e.g. hover) which cannot be done in JSX
 * file without introducing unnecessary state variables
 *
 * Since swx-atomic-component-lib supports styled component, it is the best
 * css-in-js approach to solve our problem
 */

export const UserListContainer = styled(Paper)`
  border-radius: 0 !important;
  padding: 0 10px 0 10px !important;
  position: absolute !important;
  z-index: 2 !important;
  width: 420px !important;
  max-height: 400px !important;
  overflow: auto !important;

  ::-webkit-scrollbar:horizontal {
    height: 7px !important;
  }

  ::-webkit-scrollbar {
    width: 7px !important;
  }
  ::-webkit-scrollbar-track {
    background: ${SwxTheme.palette.g300} !important;
  }
  ::-webkit-scrollbar-thumb {
    background: ${SwxTheme.palette.g700} !important;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${SwxTheme.palette.g800} !important;
  }
`

export const UserListItem = styled(ListItem)`
  padding: 10px !important;
  color: ${SwxTheme.palette.black} !important;

  &:hover {
    background-color: ${SwxTheme.palette.primary} !important;
  }

  > div > span {
    color: ${SwxTheme.palette.black} !important;
  }

  > div > p {
    color: ${SwxTheme.palette.secondary} !important;
  }

  &:hover > div > span,
  &:hover > div > p {
    color: ${SwxTheme.palette.white} !important;
  }
`

export const LoadMoreButton = styled(ListItem)`
  padding: 10px !important;
  display: flex !important;
  justify-content: center !important;
  background-color: ${SwxTheme.palette.g50} !important;
`
